var _style, _path, _circle, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrescription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prescription_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".prescription_svg__st1{fill:none}.prescription_svg__st3{fill:#35a4dd}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f9af17",
    d: "M368.4 688.1c17.9 0 32.5-14.6 32.5-32.5V565h32.8l103.7 145.1-71.4 89.2c-11.2 14-8.9 34.5 5.1 45.7 5.8 4.6 13 7.1 20.3 7.1 9.9 0 19.2-4.4 25.4-12.2l59.8-74.8 52.4 73.4c6.1 8.5 16 13.6 26.5 13.6 6.8 0 13.3-2.1 18.9-6.1 7-5 11.7-12.5 13.2-21.1 1.4-8.6-.6-17.2-5.6-24.2l-63.1-88.3 62-77.5c11.2-14 8.9-34.5-5.1-45.7-5.8-4.6-13-7.1-20.3-7.1-9.9 0-19.2 4.4-25.4 12.1l-50.6 63.2-75.7-106c15.8-8.3 29.4-20.2 39.9-34.8 13.9-19.4 21.2-42.2 21.2-66.1 0-63.2-51.4-114.5-114.5-114.5h-82c-17.9 0-32.5 14.6-32.5 32.5v287.1c0 17.9 14.5 32.5 32.5 32.5zm82-188.1h-49.5v-99h49.5c27.3 0 49.5 22.2 49.5 49.5S477.7 500 450.4 500z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 860.6,
    cy: 401.6,
    r: 32.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M717 212.9h65l-94-94.1v65.1c0 16 13 29 29 29z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M893.2 306.1c0-1.2-.1-2.3-.2-3.5v7c.1-1.2.2-2.3.2-3.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M688 183.9c0 16 13 29 29 29h65l-94-94.1v65.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M883.5 222.4l-205.1-205c-6.1-6.1-14.3-9.5-23-9.5H224.8c-51.8 0-94 42.2-94 94v820.3c0 51.8 42.2 94 94 94H799c51.8 0 94-42.2 94-94V493.5c-1.7-16.4-15.6-29.1-32.4-29.1-18 0-32.6 14.6-32.6 32.6v425.1c0 16-13 29-29 29H224.8c-16 0-29-13-29-29V101.9c0-16 13-29 29-29h398.1v111c0 51.8 42.2 94 94 94h111v28.2c0 18 14.6 32.6 32.6 32.6 16.8 0 30.7-12.8 32.4-29.1v-64.2c.1-8.7-3.3-16.8-9.4-23zM717 212.9c-16 0-29-13-29-29v-65.1l94.1 94.1H717z"
  })));
}

export default SvgPrescription;